/**
 * Dynamite override for the UGC expanded ("Shop The Look") headings.
 *
 * Realm 1 (SFRA) Dynamite spec: same metrics as Garage, but regular weight in
 * AzoSans (already the Dynamite `fonts.heading` token) and no casing change.
 * Mobile's drawer toggle gets the same treatment so "Shop The Look" is regular
 * weight and Title Case there too, matching desktop.
 */
export default {
    baseStyle: {
        shopTheLookTitle: {
            fontWeight: 'normal',
            textTransform: 'none'
        },
        moreLooksTitle: {
            textTransform: 'none'
        },
        drawerToggleLabel: {
            fontWeight: 'normal',
            textTransform: 'none'
        }
    }
}
